/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Plan_Starter_IncludesInputs */



/**
* | output |
* | --- |
* | "Everything in Free, and:" |
*
* @param {Signup_Plan_Starter_IncludesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_plan_starter_includes = /** @type {((inputs?: Signup_Plan_Starter_IncludesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Plan_Starter_IncludesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Everything in Free, and:")
	if (locale === "de") return /** @type {LocalizedString} */ ("Everything in Free, and:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Everything in Free, and:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Everything in Free, and:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Everything in Free, and:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Everything in Free, and:")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Everything in Free, and:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Everything in Free, and:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Everything in Free, and:")
	return /** @type {LocalizedString} */ ("Everything in Free, and:")
});